import type {
  GatsbySSR,
  GatsbyBrowser,
  WrapPageElementNodeArgs,
  WrapPageElementBrowserArgs,
} from 'gatsby';
import React from 'react';
import cx from 'classnames';

import { themeClass as paletteClass } from '#blog/theme/palette.css';
import { themeClass as shapeClass } from '#blog/theme/shape.css';
import { themeClass as spacingClass } from '#blog/theme/spacing.css';
import { themeClass as transitionClass } from '#blog/theme/transition.css';
import { themeClass as typographyClass } from '#blog/theme/typography.css';
import { themeClass as shadowClass } from '#blog/theme/shadow.css';

import * as styles from './Page.css';

export const Page:
  | GatsbyBrowser['wrapPageElement']
  | GatsbySSR['wrapPageElement'] = ({
  element,
}: WrapPageElementBrowserArgs | WrapPageElementNodeArgs) => {
  return (
    <div
      className={cx(
        styles.page,
        paletteClass,
        shapeClass,
        spacingClass,
        transitionClass,
        typographyClass,
        shadowClass,
      )}
    >
      {element}
    </div>
  );
};
